
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import {fetch, promptMessage} from '@/api/dataHandling'
import {urlConfig} from '@/api/urlConfig'
import {getken} from '@/api/getToken'
import {getUrlParam} from '@/utils/urlUtil'

/**
*/
export default {
name: 'startExam',
directives: {
TransferDom
},
components: {
Group, Cell, XHeader, Grid, GridItem, Divider, Card, XButton, XDialog, Loading, XInput
},
data () {
return {
loadingShow: false,
queryParam: {
id: undefined
},
mdtInfo: {
id: undefined,
mdtHId: undefined,
personInfoId: undefined,
specType: undefined,
patientName: undefined,
identityNo: undefined,
phone: undefined,
visitDate: undefined,
visitInterval: undefined,
accept: undefined,
remark: undefined,
speacUserId: undefined,
secretUserId: undefined
},
visitTime: undefined
}
},
created () {
getken()
this.loadingShow = true
this.getSpeacInfo() 
},
mounted () {},
methods: {
getSpeacInfo: function () {

this.queryParam.id = getUrlParam('id')
/*    this.queryParam.id = '4028718174ce34c90174ce3a95dd0007'*/
fetch('post', urlConfig.queryMdtRespByDid + '?detailId=' + this.queryParam.id).then(resp => {
this.loadingShow = false
this.mdtInfo = resp
this.visitTime = this.mdtInfo.visitDate + ' ' + this.mdtInfo.visitInterval
})
},
sureOk: function () {
this.mdtInfo.accept = '1'
this.subCommit()
},
sureNo: function () {
this.mdtInfo.accept = '2'
this.subCommit()
},
subCommit () {
console.log(JSON.stringify(this.mdtInfo))
fetch('post', urlConfig.updateMdtStatus, this.mdtInfo).then(resp => {
promptMessage('保存成功！')
}).catch(() => {})
}
}
}



// WEBPACK FOOTER //
// ./src/project/mdt/mdtSpeacInfo.vue